import React, { useState, useEffect, useRef } from "react";
import { convertDate } from "../../Helper";
import { convertDateToIndianFormat } from "../../Helper";
// import { GLOBAL_URL } from "../../../API/global";
import { useParams, useNavigate } from "react-router-dom";
import { getRequestGlobal } from "../../../API/global";
import { getRequest, postRequest } from "../../../API/IP";
import { useReactToPrint } from "react-to-print";
import Button from "@mui/material/Button";
import { Container } from "@mui/material";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
// import Checkbox from "@mui/material/Checkbox";
// import logo from '../../../images/pecock.png';
// import logo from "../../../assets/images/IFFFI_LOGO.png";
import logo from "../../../assets/images/IFFFI_LOGO.png";
import logo1 from "../../../images/ashok-logo.png";
// import logo2 from "../../../images/NFDC-Logo.png";
import NFDCimg from "../../../assets/images/NFDC-Logo.png";
import { styled } from "@mui/system";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// Define the custom style
const StickyButton = styled(Button)({
  position: "fixed",
  bottom: "10px", // Or top: '10px' for top positioning
  right: "10px",
  zIndex: 1000,
});
const IpView = () => {
  const [preData, setPredata] = useState([]);
  const [language, setLanguage] = useState({});
  const [formData, setFormData] = useState(null);
  const { id = null, ip_step = 1 } = useParams();
  const [currDate, setCurrDate] = useState("");
  const [currTime, setCurrTime] = useState("");
  const [preEpisodeData, setPreEpisodeData] = useState([]);
  const [predataFilmfest, setpredataFilmfest] = useState([]);
  const [predataBroadcast, setpredataBroadcast] = useState([]);
  const [preDataInside, setpreDataInside] = useState([]);

  const [preDataOutsid, setpreDataOutsid] = useState([]);
  const [preDataInter, setpreDataInter] = useState([]);
  const [preDataAward, setpreDataAward] = useState([]);
  const navigate = useNavigate();
  const loadpreData = async () => {
    if (id) {
      try {
        const response = await getRequest(`ip_details/${id}`, {});
        const loadpredata = response.data;

        const predataResponse = await postRequest("ip_co_producers/list", {
          ip_application_form_id: id,
        });
        if (predataResponse?.data) {
          setPredata(predataResponse.data);
        }

        const documentData = {};
        if (loadpredata.documents) {
          for (const document of loadpredata.documents) {
            documentData[document.type] = {
              file: document.file,
              name: document.name,
            };
          }
        }
        loadpredata.documentData = documentData;

        setFormData(loadpredata); // Assuming response structure
        // setExpanded(true); // Expand the accordion when data is fetched
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      console.error("No ID provided.");
    }
  };

  useEffect(() => {
    const date = new Date();
    setCurrDate(date.toLocaleDateString());
    setCurrTime(date.toLocaleTimeString());

    loadpreData();
    getRequestGlobal("language_list", {})
      .then((data) => {
        setLanguage(data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
    // handlePrint();

    if (formData?.id) {
      loadData();
    }
  }, [formData]);
  const loadData = async () => {
    const episodeResponse = await getRequest(
      `${formData.id}/ip-director`,
      formData,
    );
    const episodeData = episodeResponse.data;
    setPreEpisodeData(episodeData);
    const predataFilmfest = await getRequest(`${formData.id}/film-festival`);
    if (predataFilmfest?.data) setpredataFilmfest(predataFilmfest?.data);

    const predataBroadcast = await getRequest(`${formData.id}/ip-broadcasted`);
    if (predataFilmfest?.data) setpredataBroadcast(predataBroadcast?.data);

    const preDataInside = await getRequest(`${formData.id}/ip-inside`);
    if (preDataInside?.data) setpreDataInside(preDataInside?.data);

    const preDataOutsid = await getRequest(
      `${formData.id}/commercially-outside`,
    );
    if (preDataOutsid?.data) setpreDataOutsid(preDataOutsid?.data);
    const preDataInter = await getRequest(
      `${formData.id}/international-competition`,
    );
    if (preDataInter?.data) setpreDataInter(preDataInter?.data);
    const preDataAward = await getRequest(`${formData.id}/ip-award`);
    if (preDataAward?.data) setpreDataAward(preDataAward?.data);
  };

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "IpView",
  });

  const handleRedirect = (tabName) => {
    navigate(`/dashboard/${tabName}`);
  };

  // Handler to expand accordion panels
  // const [expanded, setExpanded] = useState('panel1');
  // const handleChange = (panel) => (event, newExpanded) => {
  //     setExpanded(newExpanded ? panel : false);
  // };

  if (!formData) {
    return <p>Loading...</p>;
  }
  const toRoman = (num) => {
    const romanNumerals = [
      ["XL", 40],
      ["X", 10],
      ["IX", 9],
      ["V", 5],
      ["IV", 4],
      ["I", 1],
    ];

    let roman = "";
    for (let [letter, value] of romanNumerals) {
      while (num >= value) {
        roman += letter;
        num -= value;
      }
    }
    return roman;
  };
  // const lengthInRoman = toRoman(preEpisodeData.length);

  return (
    <>
      <div ref={printRef} style={{ width: "100%" }}>
        <div className="print-header">
          <div className="d-flex justify-content-between m-1 align-items-center">
            <div className="imgLogo">
              <a href={process.env.REACT_APP_BASE_PREFIX + "/dashboard"}>
                <img
                  src={logo}
                  className="mob-logo-left"
                  alt="Logo"
                  width="130px"
                  height="100"
                />
              </a>
            </div>
            <div className="imgLogo">
              <img
                src={logo1}
                alt="Logo"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <div className="imgLogo">
              <img
                src={NFDCimg}
                className="mob-logo-right"
                alt="Logo"
                width="130"
                height="100"
              />
            </div>
          </div>
          <Container>
            <div className="text-center m-3">
              <h4>Indian Panorama 2026</h4>
              <h5>FORM IP - 1</h5>
            </div>
          </Container>
        </div>
        <Container>
          {/* Note */}
          <div>
            <Container className="note_p">
              <h5>Instruction</h5>
              <p>
                (1) Please exercise great care in filling out this form as it is
                the PRIMARY SOURCE of the data for NFDC and will be reflected in
                its publications. No request for a change of details would be
                entertained at any stage.
              </p>
              <p>
                (2) The Producer must ensure that the name indicated in the
                entry form tallies with the credit titles appearing in the Film.
              </p>
              <p>(3) Entry Form must be filled by the Producer only</p>
              <p>
                (4) Fields marked with <sup className="text-danger">*</sup> are
                mandatory
              </p>
              <p>
                (5) The last date for submitting the online entry form is 24
                <sup>th</sup> August 2026 till 6:00 PM. The last date for
                receiving the hard copy of the filled online form along with the
                requisite materials is 31<sup>th</sup> August 2026 till 6:00 PM.
                (NOTE:- Both versions of applications form must be the same.)
              </p>
              <p>
                (6) Original signed & stamped Form IP-I, Form IP-II, &
                Declaration (as per clause No. 8.2 (c)) must be sent (in Hard
                Copy) along with all attached documents and requisite screening
                materials to the address given in the regulations within
                the given deadline. Digital signatures on original documents to be submitted are not accepted.
              </p>
              <p>
                  (7){" "}
                    {" "}
                    The submission of Online Downloadable Digital File as Back-up Copy is mandatory and it shouldn't be changed or deleted until the last of the festival i.e. <b>28 November, 2026</b>.
                </p>
            </Container>
          </div>
        </Container>

        {/* step 1 Film Details */}
        <Container className="viewPrint mt-2">
          {/* <h5><span>1. </span>Film Details</h5> */}
          <Container maxWidth="lg">
            <div class="row">
              <div className="row row-marge">
                <div class="col-md-6 alignment">
                  <p className="titleoffield-view-out">
                    <span>
                      <b>1. Category of the Film</b>
                      <sup className="text-danger"> *</sup> :
                    </span>
                  </p>
                </div>
                <div class="col-md-6 alignment">
                  <p className="titleoffield-view-span">
                    {/* {formData.category == 1
                      ? "Feature Film"
                      : "Non-feature Film"} */}

                    {formData.category == 1
                      ? "Feature Film"
                      : formData.category == 2
                        ? "Non-feature Film"
                        : formData.category == 3
                          ? "Best Debut Director of Indian Feature Film"
                          : formData.category == 4
                            ? "New Horizons (Feature Film)"
                            : ""}
                  </p>
                </div>
                <div class="col-md-6 alignment">
                  <p>
                    <span className="">
                      {formData.category == 4 ? (
                        <>
                          <b>(a)</b> Is the film eligible for New Horizons
                          (Feature Film) sub section i.e. it has not been
                          screened at any
                          festival/commercial/public/OTT/Television screening in
                          (depending on the region) the World or India (strike
                          out either the World or India as the case may be) and
                          will not be screened at any
                          festival/commercial/public/OTT/Television anywhere in
                          the World or India (strike out the World or India as
                          the case may be) before it completes its run of
                          screenings at Indian Panorama 2026 at Goa.:
                        </>
                      ) : (
                        <></>
                      )}
                    </span>
                  </p>
                </div>
                <div class="col-md-6 alignment">
                  <p>
                    <span className="titleoffield-view-span">
                      {formData.category == 4 ? (
                        <>
                          {formData.eligible_for_horizons == 1
                            ? "Yes"
                            : formData.eligible_for_horizons == 2
                              ? "No"
                              : ""}
                        </>
                      ) : (
                        <></>
                      )}
                    </span>{" "}
                  </p>
                </div>
              </div>
              <div className="row-marge">
                <p className="titleoffield-view">
                  <b>2. Title of the film</b>{" "}
                  <sup className="text-danger"> *</sup>
                </p>
                <Container maxWidth="lg">
                  <div className="row">
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">
                          (a) Title of the film in Roman Script :
                        </span>
                      </p>
                    </div>

                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.title_of_film_in_roman}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">
                          (b) Title of the Film in Devanagari :{" "}
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.title_of_film_in_devanagari}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">
                          (c) English translation of the Film :
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.english_translation_of_film}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">
                          (d) Title of the Film in the script of the language of
                          the Film :
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.title_of_script_langauge}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </Container>
              </div>
              <div className="row-marge">
                <p>
                  <span className="titleoffield-view">
                    <b>3. Language of the Film</b>
                    <sup className="text-danger"> *</sup>
                  </span>
                </p>
                <Container maxWidth="lg">
                  <div className="row">
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">(a) Language of the Film :</span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.language_id
                            ? language?.[formData.language_id]
                              ? language[formData.language_id]
                              : ""
                            : ""}
                        </span>
                      </p>
                    </div>
                    {/* <div class="col-md-6 alignment"> */}
                    {formData.language_id == 20 ? (
                      <>
                        <div className="col-md-6 ">
                          <p>
                            <span className="ms-3"> Other langauge name :</span>
                          </p>
                        </div>
                        <div className="col-md-6">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.other_language_name}
                            </span>
                          </p>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {/* </div> */}
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">
                          (b) Whether Subtitled in English:
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {formData.whether_subtitle_english ? "Yes" : "No"}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </Container>
              </div>
              <div className="row-marge">
                <p className="titleoffield-view">
                  <b>4. Format of the submitted Film</b>
                  <sup className="text-danger"> *</sup>
                </p>
                <Container maxWidth="lg">
                  <div className="row">
                    <div class="col-md-12 alignment">
                      {formData.category == 1 ||
                        formData.category == 3 ||
                        formData.category == 4 ? (
                        <>
                          <p>
                            <strong>
                              (Ensure that the DCP is incorporated with Closed
                              Captioning and Audio Descriptions)
                            </strong>
                          </p>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>

                    <div class="col-md-6 alignment">
                      {/* {formData.category == 2 ? (
                        <p>Non Feature Film :</p>
                      ) : (
                        <p>Feature Film :</p>
                      )} */}
                      {formData.category == 1
                        ? "Feature Film"
                        : formData.category == 2
                          ? "Non-feature Film"
                          : formData.category == 3
                            ? "Best Debut Director of Indian Feature Film"
                            : formData.category == 4
                              ? "New Horizons (Feature Film)"
                              : ""}
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {formData.dcp == 1
                            ? "DCP"
                            : formData.dcp == 2
                              ? ""
                              : formData.dcp == 3
                                ? ""
                                : ""}
                        </span>
                      </p>
                    </div>

                    {formData.dcp == 1 ? (
                      <>
                        {/* <Container maxWidth='lg'> */}
                        {/* <div className='row'> */}
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              DCP (Unencrypted, DCI Compliant –J2K as per SMPTE
                              Standard) and online downloadable digital file as
                              back-up copy:
                            </span>
                          </p>
                        </div>

                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {formData.dci_compliant_jpeg_2000 == 1
                                ? "Yes"
                                : "No"}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              The subtitles to be burned in the picture or in TI
                              CineCanvas™ Format :
                            </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {formData.subtitle_to_be_burned_in_picture == 1
                                ? "Yes"
                                : "No"}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              The Hard Disk partition format shall be NTFS or
                              EXT2/EXT3 (with Inode size 128 bytes) :
                            </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {formData.hard_disk_format_ext2_ext3 == 1
                                ? "Yes"
                                : "No"}
                            </span>{" "}
                          </p>
                        </div>

                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              The DCP should be preferably sent in CRU Drive /
                              Hard Disk :
                            </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {formData.dcp_should_cru_hard_disk == 1
                                ? "Yes"
                                : "No"}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Is the DCP Unencrypted ?</span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {formData.is_dcp_unencrypted == 1 ? "Yes" : "No"}
                            </span>{" "}
                          </p>
                        </div>
                        {/* </div> */}
                        {/* </Container> */}
                      </>
                    ) : (
                      <></>
                    )}

                    {/* {formData.dcp == 2 ? (
                      <>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              Is the Blu-ray region free PAL ?
                            </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.blueray_region_free_pal ? "Yes" : "No"}
                            </span>{" "}
                          </p>
                        </div>
                      </>
                    ) : (
                      <></>
                    )} */}

                    {/* {formData.dcp == 3 ? (
                      <>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              Is the Pendrive containing HD Files in MP4/ MOV
                              format; Aspect ratio- 1920x1080 HD; Video codec-
                              H.264?
                            </span>
                          </p>
                        </div>

                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.is_pendrive_containing_hd_files
                                ? "Yes"
                                : "No"}
                            </span>{" "}
                          </p>
                        </div>
                      </>
                    ) : (
                      <></>
                    )} */}

                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">
                          {formData.category == 2
                            ? "Value of the DCP (Cost in Rs.)"
                            : "Value of the DCP (Cost in Rs.)"}{" "}
                          :
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.value_of_dcp_or_blueray}
                        </span>
                      </p>
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </Container>
        </Container>

        {/* step 2 Producer Details */}
        <Container className="viewPrint mt-2">
          {/* <h4><span>2. </span>Producer(s) Details</h4> */}
          <Container maxWidth="lg">
            <p className="m-0">
              <span className="titleoffield-view-out">
                <b>5. Producer(s) Details</b>{" "}
                <sup className="text-danger"> *</sup>{" "}
              </span>
            </p>
            <div className="card m-1 p-3">
              <Container maxWidth="lg">
                <div class="row">
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="">
                        (a) Whether the Producer is{" "}
                        <span className="text-danger"> *</span> :
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        {" "}
                        {formData.producer_is == 1
                          ? "Individual"
                          : "Company/Institute/Other Such Entity"}
                      </span>{" "}
                    </p>
                  </div>
                  {/* If Producer Individual */}
                  {formData.producer_is == 1 ? (
                    <>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="">
                            Whether any proprietor firm is owned by the
                            individual making entry :
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.firm_is_owned_by_individual
                              ? "Yes"
                              : "No"}
                          </span>{" "}
                        </p>
                      </div>
                    </>
                  ) : (
                    /* If Producer Company/Institute/Other Such Entity */
                    <></>
                  )}

                  <Container maxWidth="lg">
                    <div className="row ">
                      <div class="col-md-6">
                        <p>
                          <span className="">
                            (i){" "}
                            {formData.producer_is == 2
                              ? " Name of the production house"
                              : formData.producer_is == 1 &&
                                (formData.firm_is_owned_by_individual == 0 ||
                                  formData.firm_is_owned_by_individual == "0")
                                ? "Name of the producer making the entry"
                                : " Name of the Firm"}{" "}
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.name_of_firm}
                          </span>{" "}
                        </p>
                      </div>

                      <div class="col-md-6 alignment">
                        <p>
                          <span className="">(ii) E-mail :</span>
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.producer_email}
                          </span>{" "}
                        </p>
                      </div>
                      <div class="col-md-6 alignment  align-items-start">
                        <p>
                          <span className="">(iii) Address :</span>
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.producer_address}
                          </span>{" "}
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="">(iv) Landline :</span>
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.producer_landline}
                          </span>{" "}
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="">(v) Mobile :</span>
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.producer_mobile}
                          </span>{" "}
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="">(vi) Website (Optional) :</span>
                        </p>
                      </div>
                      <div class="col-md-6 alignment">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.producer_website}
                          </span>{" "}
                        </p>
                      </div>
                    </div>
                  </Container>

                  <div class="col-md-6 alignment">
                    <p>
                      <span className="">
                        Whether Company is Registered as an Indian entity -
                        Public Ltd./Private Ltd./Partnership/Proprietorship or
                        Whether Indian national (as per the clause number 3(d)
                        Registration Details):{" "}
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        {" "}
                        {formData.company_is_registered_as_indian_entity
                          ? "Yes"
                          : "No"}
                      </span>{" "}
                    </p>
                  </div>
                  {/* <div class="col-md-6 alignment">
                                    <p><span className="">Is the address same as Producer ? : </span><span className="titleoffield-view-span">  {formData.is_address_same_as_producer ? "Yes" : "No"}</span> </p>
                                </div> */}
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="">
                        Attach Photo ID issued by the Govt. of India (for Indian
                        National) :{" "}
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[1]?.name}</u>{" "}
                      </span>
                    </p>
                  </div>
                </div>
              </Container>
            </div>
            <Container maxWidth="lg">
              <div class="row">
                {/* <p>6  </p> */}

                {preData.map((item, index) => (
                  <div className="col-md-12">
                    <div className="card m-1" style={{ width: "100%" }}>
                      <div className="card-body">
                        <p>
                          ({toRoman(index + 1)}){" "}
                          {item.producer_type == "Producer"
                            ? "Producer Details"
                            : "Co-Producer Details"}
                          {/* ({toRoman(index + 1)}) Co-Producer Details{" "} */}
                          <span className="text-danger"> *</span>{" "}
                        </p>
                        <Container>
                          <div className="row">
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="">
                                  Are you the Producer or Co-Producer ?:
                                  <span className="text-danger"> *</span> :
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.producer_type == "Producer"
                                    ? "Producer"
                                    : "Co-Producer"}
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="">
                                  Whether Producer/Co-producer is{" "}
                                  <span className="text-danger"> *</span> :
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.co_producer_is == 1
                                    ? "Individual"
                                    : "Company / Institute /Other such entity"}
                                </span>{" "}
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="">Name :</span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.name}
                                </span>{" "}
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="">E-mail :</span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.email}
                                </span>{" "}
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="">Landline (Optional) : </span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.landline}
                                </span>{" "}
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="">Mobile : </span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.mobile}
                                </span>{" "}
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="">Website(Optional) : </span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.website}
                                </span>{" "}
                              </p>
                            </div>
                            <div className="col-md-6 alignment  align-items-start">
                              <p>
                                <span className="">Address : </span>
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.address}
                                </span>{" "}
                              </p>
                            </div>
                            <div className="col-md-6 alignment">
                              {item.co_producer_is == 2 ? (
                                <p>
                                  <span className="">
                                    Whether the company(s) is registered as an
                                    Indian Entity, Mention(In accordance with
                                    Clause 6.4.2) :{" "}
                                  </span>
                                </p>
                              ) : (
                                <p>
                                  Whether the Individual is an Indian National
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 alignment">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.is_indian_entity == 1 ? "Yes" : "No"}
                                </span>
                              </p>
                            </div>
                            {item.is_indian_entity == 1 ? (
                              <div className="row">
                                <div className="col-md-6">
                                  <p>
                                    Attach Photo ID issued by the Govt. of India
                                    (for Indian National):
                                  </p>
                                </div>
                                {/* <div className='col-md-6'>
                                                                        <p>
                                                                            <p className="titleoffield-view-span" >{item.documents_name}</p>
                                                                        </p>
                                                                    </div> */}

                                <div class="col-md-6">
                                  <p>
                                    <span className="titleoffield-view-span">
                                      <FilePresentIcon />
                                      <u>{item.documents_name}</u>{" "}
                                    </span>
                                  </p>
                                  {/* <p><span className="inputoffield">

                                                                            <span className="Attach_Photo_ID">
                                                                                <a href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[1]?.file}`}><span><FileDownloadIcon /> {item.documents_name}</span></a></span>
                                                                        </span>
                                                                        </p> */}
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="col-md-6">
                                  <p>Attach copy of ID Proof:</p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="titleoffield-view-span">
                                      <FilePresentIcon />
                                      <u>{item.documents_name1}</u>{" "}
                                    </span>
                                  </p>
                                  {/* <p> <b> <a href={`${GLOBAL_URL}downloadfile/IP/${item.ip_application_form_id}/${item.file1}`}>{item.documents_name1}</a></b></p> */}
                                </div>
                              </>
                            )}

                            {item.co_producer_is == 2 ? (
                              <>
                                <div className="col-md-6 alignment">
                                  <p>
                                    <span className="">
                                      Registration Details :
                                    </span>
                                  </p>
                                </div>

                                <div className="col-md-6 alignment">
                                  <p>
                                    <span className="titleoffield-view-span">
                                      {" "}
                                      {item.registration_details}
                                    </span>{" "}
                                  </p>
                                </div>

                                {/* <div className="col-md-6 alignment">
                                  <p>
                                    <span className="">
                                      The name of the Producer along with
                                      Co-Producers(s), if any, who is to be
                                      credited in the Certificate :
                                    </span>
                                  </p>
                                </div>

                                <div className="col-md-6 alignment">
                                  <p>
                                    <span className="titleoffield-view-span">
                                      {item.name_of_producers}
                                    </span>{" "}
                                  </p>
                                </div> */}
                              </>
                            ) : (
                              ""
                            )}

                            {/* {item.co_producer_is == 1 ? (
                              <>
                                <div className="col-md-6 alignment">
                                  <p>
                                    <span className="">
                                      The name of the Producer along with
                                      Co-Producers(s), if any, who is to be
                                      credited in the Certificate :
                                    </span>
                                  </p>
                                </div>

                                <div className="col-md-6 alignment">
                                  <p>
                                    <span className="titleoffield-view-span">
                                      {item.name_of_producers}
                                    </span>{" "}
                                  </p>
                                </div>
                              </>
                            ) : (
                              ""
                            )} */}
                          </div>
                        </Container>
                      </div>
                    </div>
                  </div>
                ))}
                {preData.length ? (
                  <>
                    <div className="col-md-6">
                      <p>
                        The name of the Producer along with Co-Producers(s), if
                        any ( who is to be credited in the Certificate ):
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>{formData.co_producer_names}</p>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div class="col-md-6 alignment">
                  <p>
                    <span className="">
                      (b) Whether the Indian and Foreign right holder is
                      same:{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6 alignment">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.whether_indian_foreign_right_holder_same
                        ? "Yes"
                        : "No"}
                    </span>{" "}
                  </p>
                </div>
                {formData.whether_indian_foreign_right_holder_same == 0 ? (
                  <>
                    <Container maxWidth="lg">
                      <div className="row">
                        <div class="col-md-6 alignment">
                          {formData.right_holder_name ? (
                            <>
                              <p>
                                <span className="">(i) Name : </span>
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div class="col-md-6 alignment">
                          {formData.right_holder_name ? (
                            <>
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {formData.right_holder_name}
                                </span>{" "}
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">(ii) E-mail : </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.right_holder_email}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              (iii) Landline (Optional) :{" "}
                            </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.right_holder_landline}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">(iv) Mobile : </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.right_holder_mobile}
                            </span>{" "}
                          </p>
                        </div>
                        {/* <div class="col-md-6 alignment">
                                            {formData.right_holder_fax ? <><p><span className="" Fax : </span><span className="titleoffield-view-span">  {formData.right_holder_fax}</span> </p></> : <></>}

                                        </div> */}

                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">(v) Website (Optional) : </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.right_website}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment  align-items-start">
                          <p>
                            <span className="">(vi) Address : </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.right_holder_address}
                            </span>{" "}
                          </p>
                        </div>
                      </div>
                    </Container>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Container>
          </Container>
        </Container>

        <Container maxWidth="lg" className="mt-2">
          <p className="m-0">
            <span className="titleoffield-view-out">
              <b>6. DCP of the Film to be returned to</b>{" "}
              <sup className="text-danger"> *</sup>
            </span>
          </p>
          <div className="row viewPrint">
            <div class="col-md-6 alignment">
              <p>
                <span className="">(a) Is the address same as Producer : </span>
              </p>
            </div>
            <div class="col-md-6 alignment">
              <p>
                <span className="titleoffield-view-span">
                  {" "}
                  {formData.is_address_same_as_producer ? "Yes" : "No"}
                </span>{" "}
              </p>
            </div>
            {formData.is_address_same_as_producer == 0 ? (
              <>
                <Container maxWidth="lg">
                  <div className="row">
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">(i) Name : </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.return_address_name}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">(ii) E-mail : </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.return_address_email}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">(iii) Landline (Optional) : </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.return_address_landline}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">(iv) Mobile: </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.return_address_mobile}
                        </span>{" "}
                      </p>
                    </div>

                    <div class="col-md-6 alignment">
                      <p>
                        <span className="">(v) Website (Optional) : </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.return_website}
                        </span>{" "}
                      </p>
                    </div>

                    <div class="col-md-6 alignment  align-items-start">
                      <p>
                        <span className="">(vi) Address : </span>
                      </p>
                    </div>
                    <div class="col-md-6 alignment">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.return_address}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </Container>
              </>
            ) : (
              <></>
            )}
          </div>
        </Container>

        {/* step 3 Director Details */}
        <Container className="viewPrint mt-2">
          <p className="m-0">
            <span className="titleoffield-view-out">
              <b>7. Director(s) Details</b>
              <sup className="text-danger"> *</sup>{" "}
            </span>
          </p>
          {/* <h4><span>3. </span>Director(s) Details</h4> */}
          <Container maxWidth="lg">
            <div className="row">
              {preEpisodeData.map((row, index) => (
                <div className="card m-1 " key={index}>
                  <div className="card-body">
                    <p className="">
                      ({toRoman(index + 1)}) Director Details{" "}
                      <span className="text-danger"> *</span>
                    </p>
                    <Container maxWidth="lg">
                      <div className="row">
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Name : </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {row.name}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">E-mail : </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {row.email}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Landline (Optional) : </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {row.landline}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Mobile : </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {row.mobile}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Website (Optional) : </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {row.website}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment  align-items-start">
                          <p>
                            <span className="">Address : </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {row.address}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Indian National :</span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {row.indian_nationality ? "Yes" : "No"}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              Upload Your File in PDF Format Only :{" "}
                            </span>
                            <span className="titleoffield-view-span">
                              <FilePresentIcon />{" "}
                              <u>{row?.documents?.[0]?.name}</u>{" "}
                            </span>{" "}
                          </p>
                        </div>
                      </div>
                    </Container>
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </Container>

        {/* step 4 Crew Details */}
        <Container className="viewPrint mt-2">
          {/* <h4><span>4. </span>Crew Details</h4> */}
          <p className="m-0">
            {" "}
            <span className="titleoffield-view-out">
              <b>8. Crew Details</b>
              <sup className="text-danger"> *</sup>
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(a) Story Writer/ Author : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.story_write_aurthor}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(b) Screenplay/ Script Writer : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.screenplay_script_write}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(c) Director of Photography : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.director_of_photography}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(d) Editor : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.editor}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(e) Art Director : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.art_director}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(f) Costume Designer : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.costume_designer}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(g) Music Director : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.music_director}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(h) Sound Recordist : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.sound_recordist}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(i) Sound Re-recordist (Optional) : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.sound_re_recordist}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(j) Principal Cast : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.principal_cast}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6 alignment">
                <p>
                  <span className="">
                    (k) Duration/Running time (minutes : seconds) :
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {formData.duration_running_time} :{" "}
                    {formData.duration_running_time_seconds}
                  </span>
                </p>
              </div>

              <div class="col-md-6 alignment">
                <p>
                  <span className="">(l) No. of DCP (Optional) : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.no_of_dcp_blueray}
                  </span>{" "}
                </p>
              </div>

              <div class="col-md-6 alignment">
                <p>
                  <span className="">(m) Colour or B&W : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.color_b_w}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(n) Aspect Ratio : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.aspect_ratio}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">(o) Sound System : </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.sound_system}
                  </span>{" "}
                </p>
              </div>
            </div>
          </Container>
        </Container>

        {/* step 5 CBFC Certification */}
        <Container className="viewPrint mt-2">
          <p className="m-0">
            <span className="titleoffield-view-out">
              <b>9. CBFC Certification</b>
              <sup className="text-danger"> *</sup>
            </span>
          </p>
          {/* <h4><span>5. </span>CBFC Certification</h4> */}
          <Container maxWidth="lg">
            <div className="row">
              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    Whether the Film is certified by CBFC ? :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_is_certified_by_cbfc_or_uncensored == 1
                      ? "Yes"
                      : "No"}
                  </span>{" "}
                </p>
              </div>
              {formData.film_is_certified_by_cbfc_or_uncensored == 1 ? (
                <>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="">(a) Date of CBFC certificate : </span>
                    </p>
                  </div>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        {convertDateToIndianFormat(
                          formData.date_of_cbfc_certificate,
                        )}
                      </span>{" "}
                    </p>
                  </div>

                  <div class="col-md-6 alignment">
                    <p>
                      <span className="">(b) Certification No : </span>
                    </p>
                  </div>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        {" "}
                        {formData.certificate_no}
                      </span>{" "}
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <span className="">
                        (c) Attach Copy Of CBFC Certificate :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[4]?.name}</u>{" "}
                      </span>
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="">
                        (a) Date of Completion of Production :{" "}
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        {convertDateToIndianFormat(
                          formData.date_of_completion_production,
                        )}
                      </span>{" "}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <p>
                      <span className="">
                        (b) Attach Copy Of Declaration As per Clause ( 8.2 (C)
                        ):{" "}
                      </span>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[3]?.name}</u>
                      </span>
                    </p>
                  </div>
                </>
              )}
            </div>
          </Container>
        </Container>

        {/* step 6 Other Details */}
        <Container className="viewPrint mt-2">
          {/* <h4><span>6. </span>Other Details</h4> */}
          <p className="m-0">
            {" "}
            <span className="titleoffield-view-out">
              <b>10. Other Details</b> <sup className="text-danger"> *</sup>
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div class="col-md-6 alignment">
                <p>
                  A.
                  <span className="">
                    Whether the Film has been completed between 1st August, 2025
                    and 31st July, 2026 :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_comletion_during_12month ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    B. Whether the Film has been screened in any Indian or
                    International Film Festival and if so, where and when?
                    :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_screened ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>

              {formData.film_screened == 1 ? (
                <>
                  {predataFilmfest.map((item, index) => (
                    <div className="card m-1">
                      <div className="card-body">
                        <p>({toRoman(index + 1)}) Festival Details</p>
                        <Container>
                          <div className="row">
                            <div class="col-md-6 alignment">
                              <p>
                                <span className="">
                                  Name of the Festival :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.name_of_festival}
                                </span>{" "}
                              </p>
                            </div>
                            <div class="col-md-6 alignment">
                              <p>
                                <span className="">
                                  Address of the Festival :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.address_of_festival}
                                </span>{" "}
                              </p>
                            </div>
                            <div class="col-md-6 alignment">
                              <p>
                                <span className="">
                                  Date of the Festival :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {convertDateToIndianFormat(
                                    item.date_of_festival,
                                  )}
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                        </Container>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}

              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    C. Whether the Film has been shown/broadcast on Internet/TV
                    or other media if so, where and when? :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_broadcast_tv ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>

              {formData.film_broadcast_tv == 1 ? (
                <>
                  {predataBroadcast.map((item, index) => (
                    <div className="card m-1">
                      <div className="card-body">
                        <p>({toRoman(index + 1)}) Broadcast Details</p>
                        <Container>
                          <div className="row">
                            <div class="col-md-6 alignment">
                              <p>
                                <span className="">Streaming Platform : </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.name}
                                </span>{" "}
                              </p>
                            </div>
                            {/* <div class="col-md-6 alignment">
                              <p>
                                <span className="">
                                  Address of the Festival :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.address}
                                </span>{" "}
                              </p>
                            </div> */}
                            <div class="col-md-6 alignment">
                              <p>
                                <span className="">Date of Streaming : </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {convertDateToIndianFormat(item.date)}
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                        </Container>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}

              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    D. Whether the Film has been screened commercially inside
                    India and if so, where and when? :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_screened_inside_india == 1 ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>

              {/* {formData.film_screened_inside_india == 1 ? (
                <>
                  <div className="card m-1">
                    <div className="card-body">
                      <div className="row">
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Date Of Release : </span>
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.date_of_release_india}
                            </span>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )} */}

              {formData.film_screened_inside_india == 1 ? (
                <>
                  {preDataInside.map((item, index) => (
                    <div className="card m-1">
                      <div className="card-body">
                        <p>
                          ({toRoman(index + 1)}) Commercially inside Details
                        </p>
                        <Container>
                          <div className="row">
                            <div class="col-md-6 alignment">
                              <p>
                                <span className="">Name of the venue : </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.name}
                                </span>{" "}
                              </p>
                            </div>
                            {/* <div class="col-md-6 alignment">
                              <p>
                                <span className="">
                                  Address of the Festival :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.address}
                                </span>{" "}
                              </p>
                            </div> */}
                            <div class="col-md-6 alignment">
                              <p>
                                <span className="">Date of screening : </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {convertDateToIndianFormat(item.date)}
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                        </Container>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}

              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    E. Whether the Film has been screened commercially outside
                    India, and if so, where and when? :
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_screened_outside_india ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>
              {formData.film_screened_outside_india == 1 ? (
                <>
                  {preDataOutsid.map((item, index) => (
                    <div className="card m-1">
                      <div className="card-body">
                        <div className="row">
                          <div class="col-md-6 alignment">
                            <p>
                              <span className="">
                                ({toRoman(index + 1)}) Name of the country
                                screened :{" "}
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.name}
                              </span>{" "}
                            </p>
                          </div>
                          {/* <div class="col-md-6 alignment">
                            <p>
                              <span className="">
                                Address of the festival :{" "}
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.country}
                              </span>{" "}
                            </p>
                          </div> */}
                          <div class="col-md-6 alignment">
                            <p>
                              <span className="">Date of the screening : </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {convertDateToIndianFormat(item.release_date)}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}

              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    F. Whether the Film has participated in any International
                    Competition, and if so, where and when? :
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_participated_compentitaion ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>

              <>
                {formData.film_participated_compentitaion == 1 ? (
                  <>
                    {preDataInter.map((item, index) => (
                      <div className="card m-1">
                        <div className="card-body">
                          <div class="col-md-6 alignment">
                            <p>
                              <span className="">
                                ({toRoman(index + 1)}) Name of the festival
                                :{" "}
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.name}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6 alignment">
                            <p>
                              <span className="">Address: </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.address}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6 alignment">
                            <p>
                              <span className="">Date of the festival :</span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {convertDateToIndianFormat(item.date)}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </>

              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    G. Details of the Award won, if any :
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.is_ip_award ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>

              {formData.is_ip_award == 1 ? (
                <>
                  {preDataAward.map((item, index) => (
                    <div className="card m-1">
                      <div className="card-body">
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              ({toRoman(index + 1)}) Name of the festival :{" "}
                            </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {item.name}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Address: </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {item.address}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">Date of the festival:</span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {convertDateToIndianFormat(item.date)}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6 alignment">
                          <p>
                            <span className="">
                              {" "}
                              Name of the Awards won(if any) :
                            </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {item.details}
                            </span>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}

              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    H. Whether Film's distribution is limited to India only
                    :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.film_distribution_limited_to_india_only
                      ? "Yes"
                      : "No"}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    I. Whether, it is Director's Debut Film :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.is_directore_debute_film ? "Yes" : "No"}
                  </span>{" "}
                </p>
              </div>

              <div class="col-md-6 alignment">
                <p>
                  {formData.is_directore_debute_film == 1 ? (
                    <>
                      <span className="">
                        Enclosed the Declaration Letter (as per the clause No.
                        8.2c) :{" "}
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.category == 3 ? (
                      <>
                        {formData.enclosed_the_declaration_letter ? "Yes" : ""}
                      </>
                    ) : (
                      <></>
                    )}{" "}
                  </span>{" "}
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.category == 3 ? (
                      <>
                        {formData.enclosed_the_declaration_letter ? "Yes" : ""}
                      </>
                    ) : (
                      <></>
                    )}{" "}
                    {formData.category == 1 ||
                      formData.category == 2 ||
                      formData.category == 4 ? (
                      <>
                        {formData.enclosed_the_declaration_letter
                          ? "Yes"
                          : "No"}
                      </>
                    ) : (
                      <></>
                    )}{" "}
                  </span>{" "}
                </p>
              </div>

              <div class="col-md-6 alignment">
                <p>
                  <span className="">
                    J. Whether it can be confirmed that the film has neither
                    released nor planned to be releases in India/Outside India
                    until it has completed its run at IFFI 2026? :
                  </span>
                </p>
              </div>
              <div class="col-md-6 alignment">
                <p>
                  <span className="titleoffield-view-span">
                    {" "}
                    {formData.confirmation_neither_released_nor_planned
                      ? "Yes"
                      : "No"}
                  </span>{" "}
                </p>
              </div>

              {/* {preDataAward.map((item, index) => (
                <div className="card m-1">
                  <div className="card-body">
                    <div class="col-md-12 alignment">
                      <p>
                        <span className="">
                          ({toRoman(index + 1)}) Details of the Awards won (if
                          any) :{" "}
                        </span>
                        <span className="titleoffield-view-span">
                          {" "}
                          {item.details}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </div>
              ))} */}
            </div>
          </Container>
        </Container>

        {/* step 7 Documents */}
        <Container className="viewPrint mt-2">
          <p className="m-0">
            <span className="titleoffield-view-out">
              <b>
                11. Documents (For Feature Film, Non-Feature Film and films
                under Best Debut Director of Indian Feature Film, New Horizons
                (Feature Film))
              </b>{" "}
              <span className="text-danger"> *</span>
            </span>
          </p>
          {/* <h4><span>7. </span>Documents</h4> */}
          <Container maxWidth="lg">
            <div className="row">
              <p>
                11.1.
                <span className="">
                  Upload Documents <span className="text-danger"> *</span>{" "}
                  :{" "}
                </span>
              </p>
              <Container>
                <div className="row">
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="">
                        (a) Authorisation Letter in Favour Of NFDC (FORM
                        I.P.-II) in PDF :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[5]?.name}</u>{" "}
                      </span>{" "}
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="">
                        (b) Declaration Letter (As Per The Clause No 8.2(C)) in
                        PDF :
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />{" "}
                        <u>{formData?.documentData?.[6]?.name}</u>
                      </span>{" "}
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <span className="">
                        (c) Synopsis in English (Not Exceeding 150 Words) :
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span">
                        {formData?.synopsis || "Not provided"}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">
                        ((d) Director(s) Profile (Not Exceeding 100 words) &
                        Note (Not Exceeding 30 words) :
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span">
                        {formData?.director_note || "Not provided"}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">
                        e) Producer(s) Profile (Not Exceeding 100 words) :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span">
                        {formData?.producer_note || "Not provided"}
                      </span>
                    </p>
                  </div>

                  {/* <div className="col-md-6 alignment">
                    <p>
                      <span className="">
                        (c) Synopsis in English (Not Exceeding 200 Words) In
                        .Doc format :
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[7]?.name}</u>{" "}
                      </span>{" "}
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="">
                        (d) Director(s) Profile (Not Exceeding 100 words) & Note
                        (Not Exceeding 30 words) In .Doc format :
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[8]?.name}</u>{" "}
                      </span>{" "}
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="">
                        (e) Producer(s) Profile (Not Exceeding 100 words) In
                        .Doc Format :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[9]?.name}</u>{" "}
                      </span>{" "}
                    </p>
                  </div> */}
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="">
                        (f) Details Of Cast & Crew In .Doc format :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <FilePresentIcon />
                        <u>{formData?.documentData?.[10]?.name}</u>{" "}
                      </span>{" "}
                    </p>
                  </div>
                </div>
              </Container>
              <p>
                11.2. Following must be mailed to{" "}
                <span style={{ color: "#AD4172", fontWeight: "800" }}>
                  indianpanorama@nfdcindia.com:-
                </span>
              </p>
              <Container>
                <div className="row">
                  <div className="col-sm-12 col-lg-12">
                    <p>
                      A:- &nbsp;Film stills (5 nos.), 200-300 dpi
                      <sup className="text-danger"> *</sup>
                    </p>
                    <p>
                      B:- &nbsp;Director(s) working stills (2 nos.), 200-300 dpi
                      <sup className="text-danger"> *</sup>
                    </p>
                    <p>
                      C:- &nbsp;Producer(s) still or logo, 200-300 dpi
                      <sup className="text-danger"> *</sup>
                    </p>
                    <p>
                      D:- &nbsp;Posters<sup className="text-danger"> *</sup>
                    </p>
                  </div>
                </div>
              </Container>
              <Container>
                <div className="row">
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="">
                        Whether the requisite documents(s) at serial no. 11.2-
                        (A) (B) (C) & (D) are sent by email:{" "}
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6 alignment">
                    <p>
                      <span className="titleoffield-view-span">
                        <AttachEmailIcon />{" "}
                        {formData.requisite_documents ? "Yes" : "No"}
                      </span>{" "}
                    </p>
                  </div>

                </div>
              </Container>
            </div>
          </Container>
        </Container>
        <Container className="viewPrint mt-2">
          <p className="m-0">
            <span className="titleoffield-view-out">
              <b>
                12. Online downloadable digital file as back-up
              </b>{" "}
              <span className="text-danger"> *</span>
            </span>
          </p>
          {/* <h4><span>7. </span>Documents</h4> */}
          <Container maxWidth="lg">
            <div className="row">


              <Container>
                <div className="row">

                  <div className="row">
                    <div class="col-md-12">

                      12.1 Online Link :{" "}
                      <a href={`${formData?.online_link}`}>
                        {formData?.online_link}
                      </a>
                    </div>
                    <div class="col-md-6">
                      12.2 Online Password: {formData?.online_password}
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </Container>
        </Container>
        {/* Dicleration & pament details */}
        <Container className="mt-4">
          <div>
            <Container className="note_p">
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/We have No Objection for screening of this film for jury or
                  any of their panels, for non-commercial public shows of the
                  film as part of promotion of quality Indian Cinema within
                  India and abroad in film festivals/special expositions
                  organized/supported by the National Film Development
                  Corporation in any digital format as well as promotion of the
                  film through the use of film stills/posters and
                  trailers/visual clips.
                </p>
              </div>
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/We also assure that this No Objection to the NFDC will
                  remain valid not-withstanding any rights assigned by me/us to
                  any other individual/organization for screening the film in
                  any territory on commercial/non-commercial basis in future.
                </p>
              </div>
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/We declare that I/We have read the Indian Panorama
                  Regulations and accept them without reservation in particular.
                </p>
              </div>
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/We note the condition of Regulations 8.2 stipulating that
                  my/our entry will be rejected unless the entry form alongwith
                  all the required material including the DCP is received by the
                  National Film Development Corporation on or before 31.08.2026
                  till 6:00 PM.
                </p>
              </div>
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/We certify that the film entered is not a
                  Dubbed/Revised/Remake/Re-edited version of a film and has not
                  been submitted earlier. And has not infringed any copyright in
                  any manner whatsoever.
                </p>
              </div>
            </Container>
          </div>
          <Container className="viewPrint mt-2">
            <p className="m-0">
              <span className="titleoffield-view-out">
                <b>13. Submission Details</b>
              </span>
            </p>
            {/* <h4>Submission Details</h4> */}
            <Container maxWidth="lg">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <span className="">(a) Submission Date : </span>
                  </p>
                </div>

                <div className="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {/* {formData?.submit_time ??
                        convertDateToIndianFormat(
                          formData?.payment_response?.created_at
                        )} */}
                      {convertDateToIndianFormat(formData?.submit_time) ??
                        convertDateToIndianFormat(
                          formData?.payment_response?.created_at,
                        )}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="">(b) Print Date : </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {currDate} , {currTime}
                    </span>
                  </p>
                </div>
              </div>
            </Container>
            {/* <Container maxWidth="lg">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <span className="">(a) Transaction Date : </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {convertDateToIndianFormat(
                        formData?.payment_response?.created_at
                      )}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="">(b) Bank Reference Number : </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData?.payment_response?.bank_ref_no}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="">(c) Amount : </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      Rs {formData?.payment_response?.amount}/-
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="">(d) Status : </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData?.payment_response?.auth_status === "0300"
                        ? "Success"
                        : "Declined"}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="">(e) Print Date : </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {currDate} , {currTime}
                    </span>
                  </p>
                </div>
              </div>
            </Container> */}
          </Container>
          <Container>
            <div className="d-flex justify-content-between mt-5">
              <div className="print_left">
                <p>Signature of Producer(s)</p>
                <p>Seal</p>
                <p>Date</p>
              </div>
              <div className="print_right">
                <p>Signature of the Rights holder(s)</p>
                <p>Seal</p>
                <p>Date</p>
              </div>
            </div>
          </Container>
        </Container>
      </div>

      <Container style={{ padding: "10px" }}>
        <div className="d-flex justify-content-between">
          <Button variant="outlined" onClick={() => handleRedirect("ip")}>
            Dashboard
          </Button>
          <StickyButton
            variant="contained"
            color="success"
            onClick={handlePrint}
          >
            Print
          </StickyButton>
        </div>
      </Container>
    </>
  );
};

export default IpView;
